export default __webpack_public_path__ + "static/media/logo_white.c59dd596.png";